import React from "react";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const pageLimitContext = React.createContext(null as any);

export default pageLimitContext;
